import React from "react";
import { intl } from "LocaleWrapper";
import { Table } from "@cofano/cck";
import { Box, IconButton, Popover } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import usePopover from "components/hooks/usePopover";
import { DataFormat } from "imports/Utils";
import { ProductLink } from "utils/LinkUtils";
import { HandlingRateFragment } from "__generated__/view/locations/graphql/location.fragments.generated";

const LocationCraneHandlingRatesPopover = ({ handlingRates }: { handlingRates: HandlingRateFragment[] }) => {

	const { popoverProps, onPopoverOpen } = usePopover({
		trigger: "click",
	});

	if (handlingRates.length > 0) {
		return (
			<React.Fragment>
				<span style={{ alignItems: "center", display: "flex" }}>
					{`${handlingRates.length} `}
					{intl.formatMessage({ id: handlingRates.length === 1 ? "PRODUCT" : "PRODUCTS" })}

					<IconButton onClick={(event) => onPopoverOpen(event)} size="small">
						<InfoOutlinedIcon fontSize="small" />
					</IconButton>
				</span>

				<Popover {...popoverProps}>
					<Box p={2} sx={{ width: 300 }}>
						<Table
							id="locationCraneHandlingRatesTable"
							content={handlingRates.map(it => ({ ...it, id: it.id || 0 }))}
							columns={[ {
								id: "product",
								title: intl.formatMessage({ id: "PRODUCT" }),
								render: (row: HandlingRateFragment) => <ProductLink product={row.product} />,
							}, {
								id: "handlingRateInTonsPerHour",
								title: intl.formatMessage({ id: "CRANE_SPEED" }),
								render: (row: HandlingRateFragment) => DataFormat.simpleUnit(row.handlingRateInTonsPerHour || 0, `${intl.formatMessage({ id: "TON" })}/h`),
							} ]}
							disableFooter />
					</Box>
				</Popover>
			</React.Fragment>
		);
	} else {
		return <React.Fragment />;
	}
};

export default LocationCraneHandlingRatesPopover;
